import { Entypo } from '@native-base/icons';
import {
  Center,
  Heading,
  HStack,
  Icon,
  ScrollView,
  Spacer,
  StatusBar,
  Text,
} from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import moneyDisplay from '../../../helpers/moneyDisplay';
import ActionButton from '../../../shared/ActionButton';
import FacesCheck from '../../../shared/FacesCheck';

function Pay({ onDone, paymentContent, paymentTotal, setCompleted }) {
  return (
    <>
      <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
      <Center bg="#F4F8FB" shadow="3" px="4" py="4">
        <Heading size="sm">À payer</Heading>
        <HStack alignItems="center" justifyContent="center">
          <Icon as={Entypo} name="arrow-bold-up" color="red.500" mr="2" />
          <Heading>{moneyDisplay(paymentTotal)}</Heading>
        </HStack>
      </Center>
      <Center bg="#caf0f8" px="4" py="2">
        <Text>Donnez et cochez les billets et pièces suivants.</Text>
      </Center>
      <ScrollView px="4" py="2">
        <FacesCheck content={paymentContent} setCompleted={setCompleted} />
      </ScrollView>
      <Spacer />
      <ActionButton onPress={onDone}>Continuer</ActionButton>
    </>
  );
}

Pay.propTypes = {
  onDone: PropTypes.func.isRequired,
  paymentContent: PropTypes.array.isRequired,
  paymentTotal: PropTypes.number.isRequired,
  setCompleted: PropTypes.func.isRequired,
};

export default Pay;
